import { ActionType, getType } from "typesafe-actions";
import * as reportActions from "./reportActions";

export interface ReportState {
  loading?: boolean;
  data?: string;
  error?: string;
}

export type ReportActions = ActionType<typeof reportActions>;

export default function report(state: ReportState = {}, action: ReportActions) {
  switch (action.type) {
    case getType(reportActions.load):
      return { ...state, loading: true };
    case getType(reportActions.loadSuccess):
      return {
        ...state,
        loading: false,
        data: action.data,
        error: undefined,
      };
    case getType(reportActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
